import { BasicLogDetails, DeviceLogDetails, ExtendedLogDetails, LogLevel } from '@shared/models/log.interface';

export class LogEntry {
  entryDate: Date = new Date();
  extendedLogDetails: ExtendedLogDetails | undefined;
  deviceLogDetails!: DeviceLogDetails | undefined;
  basicLogDetails: BasicLogDetails = {
    level: LogLevel.ALL,
    screen_route: 'UNDEFINED',
    log_event: 'UNDEFINED',
    log_message: 'UNDEFINED'
  };
  
  constructor() {}
  
  buildLogString(): string {
    let logString = "";

    // [Basic Logs]
    logString = `${new Date()}: `;
    logString += `[${LogLevel[this.basicLogDetails.level]}] `;
    logString += `${this.basicLogDetails.screen_route}.`;
    logString += `${this.basicLogDetails.log_message}.`;

    if (this.extendedLogDetails) logString += ` [Extended]: ${this.formatOptions(this.extendedLogDetails)}.`;
    if (this.deviceLogDetails) logString += ` [Device]: ${this.formatOptions(this.deviceLogDetails)}.`;
  
    return logString;
  }
  
  private formatOptions(optionalDetails: unknown): string {
    let entryNumber: number = 0;
    let formattedString: string = '';
    
    const entries = Object.entries(optionalDetails as Object);
    for (let entry of entries) {
      entryNumber += 1;
      formattedString += `${entry[0]}=${entry[1]}`;
      
      // appending comma and whitespace after each property except for last.
      if (entryNumber === entries.length) formattedString += ``;
      else formattedString += ', ';
    }

    return formattedString;
  }
}
